/**
 * Perf: Swiper proxy — carousels can call `new Swiper()` before the library
 * downloads. The real bundle loads after `window.load` so it does not compete
 * with LCP. Pending constructors are flushed once Swiper is available.
 */
(function (window, document) {
  var SWIPER_JS =
    'https://cdnjs.cloudflare.com/ajax/libs/Swiper/11.0.5/swiper-bundle.min.js';
  var SWIPER_CSS =
    'https://cdnjs.cloudflare.com/ajax/libs/Swiper/11.0.5/swiper-bundle.min.css';
  var SWIPER_JS_INTEGRITY =
    'sha512-Ysw1DcK1P+uYLqprEAzNQJP+J4hTx4t/3X2nbVwszao8wD+9afLjBQYjz7Uk4ADP+Er++mJoScI42ueGtQOzEA==';
  var SWIPER_CSS_INTEGRITY =
    'sha512-rd0qOHVMOcez6pLWPVFIv7EfSdGKLt+eafXh4RO/12Fgr41hDQxfGvoi1Vy55QIVcQEujUE1LQrATCLl2Fs+ag==';

  var RealSwiper = null;
  var pending = [];
  var loadStarted = false;
  var loadPromise = null;

  function injectCss() {
    if (document.getElementById('swiper-bundle-css')) return;
    var link = document.createElement('link');
    link.id = 'swiper-bundle-css';
    link.rel = 'stylesheet';
    link.href = SWIPER_CSS;
    link.integrity = SWIPER_CSS_INTEGRITY;
    link.crossOrigin = 'anonymous';
    link.referrerPolicy = 'no-referrer';
    document.head.appendChild(link);
  }

  function flushPending() {
    if (!RealSwiper) return;
    pending.splice(0).forEach(function (item) {
      if (item.proxy && item.proxy.__destroyed) return;
      try {
        var instance = new RealSwiper(item.el, item.opts);
        if (item.proxy) {
          item.proxy.__real = instance;
          item.proxy.update = function () {
            return instance.update.apply(instance, arguments);
          };
          item.proxy.destroy = function () {
            item.proxy.__destroyed = true;
            return instance.destroy.apply(instance, arguments);
          };
          item.proxy.slideTo = function () {
            return instance.slideTo.apply(instance, arguments);
          };
          item.proxy.slideNext = function () {
            return instance.slideNext.apply(instance, arguments);
          };
          item.proxy.slidePrev = function () {
            return instance.slidePrev.apply(instance, arguments);
          };
        }
      } catch (e) {
        console.warn('Swiper init skipped:', e);
      }
    });
  }

  function loadSwiper() {
    if (RealSwiper) return Promise.resolve(RealSwiper);
    if (loadPromise) return loadPromise;

    loadStarted = true;
    injectCss();

    loadPromise = new Promise(function (resolve, reject) {
      var script = document.createElement('script');
      script.src = SWIPER_JS;
      script.integrity = SWIPER_JS_INTEGRITY;
      script.crossOrigin = 'anonymous';
      script.referrerPolicy = 'no-referrer';
      script.onload = function () {
        RealSwiper = window.Swiper && !window.Swiper.__isProxy ? window.Swiper : null;
        if (!RealSwiper) {
          reject(new Error('Swiper failed to load'));
          return;
        }
        window.Swiper = RealSwiper;
        flushPending();
        document.dispatchEvent(new CustomEvent('swiper:ready'));
        resolve(RealSwiper);
      };
      script.onerror = function () {
        reject(new Error('Swiper script error'));
      };
      document.head.appendChild(script);
    });

    return loadPromise;
  }

  function SwiperProxy(el, opts) {
    if (RealSwiper) {
      return new RealSwiper(el, opts);
    }

    var proxy = {
      __isProxyInstance: true,
      __destroyed: false,
      __real: null,
      update: function () {},
      destroy: function () {
        this.__destroyed = true;
      },
      slideTo: function () {},
      slideNext: function () {},
      slidePrev: function () {},
    };

    pending.push({ el: el, opts: opts, proxy: proxy });

    // If something needs a carousel before window.load (rare), start loading now.
    if (document.readyState === 'complete') {
      loadSwiper();
    }

    return proxy;
  }

  SwiperProxy.__isProxy = true;

  window.Swiper = SwiperProxy;
  window.themeLoadSwiper = loadSwiper;

  function schedule() {
    if (loadStarted) return;
    var start = function () {
      loadSwiper().catch(function (e) {
        console.warn(e);
      });
    };

    if ('requestIdleCallback' in window) {
      requestIdleCallback(start, { timeout: 2500 });
    } else {
      setTimeout(start, 1);
    }
  }

  if (document.readyState === 'complete') {
    schedule();
  } else {
    window.addEventListener('load', schedule);
  }
})(window, document);
